import React, {useEffect, useState} from 'react';
import {MDBCol, MDBContainer, MDBRow, MDBTable, MDBTableBody, MDBTabsPane} from "mdb-react-ui-kit";
import {format, parseISO} from 'date-fns';
import axios from 'axios';
import DrafterInfo from '../../LawsBillDetails/Info/DrafterInfo/DrafterInfo'
import RequestorInfo from '../../LawsBillDetails/Info/RequestorInfo/RequestorInfo'
import ByRequestOfInfo from '../../LawsBillDetails/Info/ByRequestOfInfo/ByRequestOfInfo'

const convertISOToReadableTimeFormat = (date) => format(parseISO(date), "MM/dd/yy");

const Summary = ({active, bill, onClickOpenTab, ordinal}) => {

    const params = new URLSearchParams();
    params.append('legislatureOrdinal', `${ordinal}`);
    params.append('sessionOrdinal', `${bill.id.sessionId}`);
    params.append('billType', `${bill.billType}`);
    params.append('billNumber', `${bill.billNumber}`);

    let billDraft = null;
    if (bill.sessionId < 1000) {
        billDraft = bill.draft;
    }

    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    
    return (
        <MDBTabsPane show={active}>
            <MDBContainer fluid>
                <MDBRow className='g-2'>
                    <MDBCol md="9" className="ps-0">

                        {billDraft ? (
                            <MDBTable className="billTable">
                                <MDBTableBody>
                                    <tr>
                                        <td scope="row" width="225">Draft #</td>
                                        <td>{billDraft.draftNumber == null ? "No Draft number" : billDraft.draftNumber}</td>
                                    </tr>
                                    {bill.drafterStaffMemberId && (
                                        <tr>
                                            <td scope="row">Drafter</td>
                                            <td>
                                                <DrafterInfo drafterId={bill.drafterStaffMemberId}/>
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td scope="row">Requester</td>
                                        <td>
                                            <RequestorInfo requestorId={bill.draft.requesterId} requestorType={bill.draft.requesterType} legislatureId={ordinal}/>
                                        </td>
                                    </tr>
                                    {bill.draft.byRequestOfs != null && bill.draft.byRequestOfs.length > 0 && (
                                        <tr>
                                            <td scope="row">By Request of</td>
                                            <td>
                                                <ByRequestOfInfo requestors={bill.draft.byRequestOfs} />
                                            </td>
                                        </tr>
                                    )}
                                    {/*<tr>
                                        <td scope="row">Preintroduction Required</td>
                                        <td>
                                            {billDraft.preIntroRequired ? "Yes" : "No"}
                                        </td>
                                    </tr>*/}
                                    {/*{billDraft.fiscalNote && (
                                        <tr>
                                            <td scope="row">Fiscal Analyst</td>
                                            <td>Yes</td>
                                        </tr>
                                    )}*/}
                                    {billDraft.legalNote && (
                                        <tr>
                                            <td scope="row">Legal Note</td>
                                            <td>Yes</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td scope="row">Subject(s)</td>
                                        <td>
                                            {billDraft && billDraft.subjects && billDraft.subjects.length > 0 ? (
                                                billDraft.subjects.map((subject, index) => (
                                                    <span key={index}>
                                                        {subject.subjectCode.description}
                                                        {index < billDraft.subjects.length - 1 ? ', ' : ''}
                                                    </span>
                                                ))
                                            ) : (
                                                <span></span>
                                            )}
                                        </td>
                                    </tr>
                                </MDBTableBody>
                            </MDBTable>
                        ) : (
                            <MDBTable className="billTable">
                                <MDBTableBody>
                                    <tr>
                                        <td scope="row" width="225">Draft #</td>
                                        <td>{bill.id.billDraftNumber == null ? "No Draft number" : bill.id.billDraftNumber}</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">Drafter</td>
                                        <td>
                                            {bill.drafters.length > 0 ? bill.drafters.map((drafter, index) => (
                                                <span
                                                    key={index}>{drafter.lawEntity?.lastName}, {drafter.lawEntity?.firstName}</span>
                                            )) : ""}
                                        </td>
                                    </tr>
                                    {bill.requesters.length > 0 && (
                                        <tr>
                                            <td scope="row">Requester</td>
                                            <td>
                                                {bill.requesters.map((requester, index) => (
                                                    <span key={index}>
                                                        {requester.lawEntity &&
                                                        (requester.lawEntity.lastName || requester.lawEntity.firstName) ?
                                                            `${requester.lawEntity.lastName || ''}${requester.lawEntity.lastName && requester.lawEntity.firstName ? ', ' : ''}${requester.lawEntity.firstName || ''}`
                                                            : ''}
                                                        </span>
                                                ))}
                                            </td>
                                        </tr>
                                    )}
                                    {bill.requestOf.length > 0 && (
                                        <tr>
                                            <td scope="row">By Request Of</td>
                                            <td>
                                                {bill.requestOf.map((requestOf, index) => (
                                                    <span key={index}>
                                                        {requestOf.lawEntity && (requestOf.lawEntity.lastName || requestOf.lawEntity.firstName) ?
                                                            `${toTitleCase(requestOf.lawEntity.lastName || '')}${requestOf.lawEntity.lastName && requestOf.lawEntity.firstName ? ', ' : ''}${toTitleCase(requestOf.lawEntity.firstName || '')}`
                                                            : ''}
                                                    </span>
                                                ))}
                                            </td>
                                        </tr>
                                    )}

                                    {bill.fiscalNote === 'Y' && (
                                        <tr>
                                            <td scope="row">Fiscal Analyst</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td scope="row">Preintroduction Required</td>
                                        <td>
                                            {bill.preintroductionRequired === "Y" ? "Yes" : "No"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row">Category</td>
                                        <td>
                                            {bill.deadlineCategory?.name ? bill.deadlineCategory.name : ""}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row">Subject(s)</td>
                                        <td>
                                            {bill.subjects.map((subject, index) => (
                                                <span key={index}>{subject.subject.description + ", "}</span>
                                            ))}
                                        </td>
                                    </tr>
                                </MDBTableBody>
                            </MDBTable>
                        )}
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBTabsPane>
    );
};

export default Summary;